import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Storage from 'vue-ls'
import '@/components/common/common.js'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/base.css'
import '@/assets/style/style.less'
import {ACCESS_TOKEN} from "@/store/mutation-types"
import widget from "@/components/widget"
import VueArealinkage from 'vue-area-linkage';

Vue.use(VueArealinkage);
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Storage, {namespace: 'pro__', name: 'ls', storage: 'local'})
Vue.use(widget)
new Vue({
    router,
    store,
    mounted() {
        store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
    },
    render: h => h(App)
}).$mount('#app')
